import { NavigationBar } from '@travelnest/hui';
import React from 'react';
import { useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { currentUserId } from '../../../entities/auth/session/selectors';
import { IState } from '../../../store/reducer';
import { Loader } from '../../../view/components/loader/Loader';
import { useCustomersProperties, useCustomersPropertyScores } from './hooks';

export const PropertyScores = () => {
	const { getState }: { getState: () => IState } = useStore();
	const customerId = currentUserId(getState());
	const { propertyScores, loading } = useCustomersPropertyScores(customerId, true);
	const { customerProperties, loading: customerPropertiesLoading } = useCustomersProperties(customerId);
	const navigate = useNavigate();

	React.useEffect(() => {
		if (!loading && !customerPropertiesLoading && propertyScores.length > 0 && customerProperties.length > 0) {
			// this const is required so we do not redirect to a property that has score data but is not published or active
			const propertyScoresForPublishedProperties = propertyScores.filter((p) => customerProperties.find((cp) => cp.id === p.property_id));
			navigate(`/property-scores/${propertyScoresForPublishedProperties[0].property_id}/score`, { replace: true });
		} else if (!loading && !customerPropertiesLoading && propertyScores.length === 0) {
			navigate(`/not-found`, { replace: true });
		}
	}, [propertyScores, loading, customerProperties, customerPropertiesLoading]);
	return (
		<div className="portal-wrapper" style={{ height: '100vh' }}>
			<NavigationBar title="Property score" />
			<Loader loading />
		</div>
	);
};
